<template>
  <div class="enable-question-effect">
    <md-field>
      <md-select
        v-close-on-zoom
        :value="state.effect.url"
        placeholder="File"
        :disabled="readonly"
        class="media-select"
        :md-attach-to-parent="true"
        @input="selectLabAssetFile"
      >
        <md-option :key="'*clear*'">Clear selection</md-option>
        <md-optgroup
          v-for="labAsset in imageLabAssets"
          :key="labAsset.id"
          :label="labAsset.name.en"
        >
          <md-option
            v-for="file in getFilesFor(labAsset)"
            :key="file.url"
            :value="file.url"
          >
            {{ file.name }}
          </md-option>
        </md-optgroup>
      </md-select>
    </md-field>
    <help-tooltip v-if="errors && errors.length" type="error">
      <span v-for="error in errors" :key="error.message">{{ error.message }}</span>
    </help-tooltip>
  </div>
</template>

<script>
import flatten from 'lodash/flatten';
import fromPairs from 'lodash/fromPairs';
import get from 'lodash/get';
import HelpTooltip from '~lib/common/components/HelpTooltip';

export default {
  name: 'toggle-lab-effect',
  components: {
    HelpTooltip,
  },
  props: [
    'readonly',
    'emitter',
    'ikey',
    'getData',
    'putData',
    'control',
    'type',
    'labAssets',
  ],
  data() {
    return {
      state: {
        effect: {
          id: null,
          url: null,
        },
      },
    };
  },
  computed: {
    imageLabAssets() {
      return this.labAssets.filter(
        labAsset =>
          (labAsset.type === 'image' || labAsset.type === 'namedImage') &&
          this.getFilesFor(labAsset).length > 0,
      );
    },
    labAssetKeysByFileUrl() {
      return fromPairs(
        flatten(
          this.emitter.caseConf._labAssets.map(labAsset => {
            if (!labAsset.options || !labAsset.options.assets) {
              return [];
            }
            return labAsset.options.assets.map(asset => [
              asset.url,
              labAsset.key,
            ]);
          }),
        ),
      );
    },
    errors() {
      if (!this.emitter.$store) {
        return [];
      }
      return get(
        this.emitter.$store.getters['validation/errorsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
      );
    },
  },
  mounted() {
    this.state.effect = this.getData(this.ikey) || this.state.effect;
    this.emitter.trigger('process', this.control);
  },
  methods: {
    selectLabAssetFile(url) {
      if (url) {
        const labAssetKey = this.labAssetKeysByFileUrl[url];
        if (labAssetKey) {
          this.state.effect.id = labAssetKey;
          this.state.effect.url = url;
        }
      } else {
        this.state.effect.id = undefined;
        this.state.effect.url = undefined;
      }
      this.update();
    },
    getFilesFor(labAsset) {
      const { _labAssets } = this.emitter.caseConf;
      if (!_labAssets) {
        return [];
      }
      const caseLabAsset = _labAssets.find(asset => asset.id === labAsset.id);
      if (!caseLabAsset) {
        return [];
      }
      return caseLabAsset.options.assets;
    },
    update() {
      this.putData(this.ikey, {
        type: 'LAB_ASSET_AVAILABLE',
        ...this.state.effect,
        value: this.type === 'ENABLE',
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.enable-question-effect {
  display: flex;
  align-items: center;
}
</style>
